






















import { Component, Vue, Prop } from "vue-property-decorator";
import * as parseJs from "./lib/parse.js";

const convert: any = (<any>parseJs).default;

@Component
export default class Icon extends Vue {
    @Prop({
        type: String,
        required: true
    })
    name!: string;

    @Prop({
        type: [String, Number]
    })
    scale!: number | string;

    @Prop({ type: Boolean })
    spin!: Boolean;

    flip: any = {
        validator: (val: string) => {
            return val === "horizontal" || val === "vertical"
        }
    };

    @Prop({ type: String })
    label!: string;

    @Prop({ type: String })
    index!: string;

    @Prop({ type: String })
    currentIndex!: string;

    svgPath: string = "../../assets";

    get normalizedScale() {
        let scale = this.scale;
        scale = typeof scale === undefined ? 1 : Number(scale);
        if (isNaN(scale) || scale <= 0) {
            console.warn(`Invalid props: prop "scale" should be a number over 0.`, this);
            return 1
        }
        return scale
    }
    get clazz() {
        return {
            "svg-icon": true,
            spin: this.spin,
            "flip-horizontal": this.flip === "horizontal",
            "flip-vertical": this.flip === "vertical",
            active: this.index === this.currentIndex
        }
    }
    get icon() {
        // tslint:disable-next-line
        let xml = require(`!xml-loader!../../assets/${this.name}.svg`);
        const t = xml.svg.$.viewBox.split(" ");
        // if (process.env.NODE_ENV !== "production") console.info(`src/svg/${this.name}.svg has been loaded`);
        return {
            width: t[2],
            height: t[3],
            paths: convert(xml.svg)
        }
    }
    get box() {
        return `0 0 ${this.icon.width} ${this.icon.height}`
    }
    get width() {
        return this.icon.width / 112 * this.normalizedScale
    }
    get height() {
        return this.icon.height / 112 * this.normalizedScale
    }
    get style() {
        if (this.normalizedScale === 1) {
            return false
        }
        return {
            fontSize: this.normalizedScale + "em"
        }
    }
    register() {
        console.warn("inject deprecated since v1.2.0, SVG files can be loaded directly, so just delete the inject line.")
    }
    clickFn() {
        this.$emit("click");
    }
}
